import { AuthService } from '../services/auth.service';

class LoginController implements ng.IComponentController {

    private returnTo: any;

    static $inject = ['AuthService', '$state', 'Restangular'];

    constructor(
        private AuthService: AuthService,
        private $state: ng.ui.IStateService,
        private Restangular: Restangular.IService
    ) {

    }

    public $onInit = () => {
        this.AuthService.authorize();
        //console.log(this.returnTo)
    }

    private returnToOriginalState = () => {
        let state = this.returnTo.state();
        let params = this.returnTo.params();
        let options = Object.assign({}, this.returnTo.options(), { reload: true });
        if(state){
            this.$state.go(state, params, options);
        } else {
            this.$state.go('app');
        }
    };

    public login = () => {
        
        var data = {
            "grant_type": "client_credentials",
            "client_id": "TestClient",
            "client_secret": "TestClientSecret"
        };

        this.Restangular.all('token').post(data)
        .then((response) => {
            this.AuthService.SetAuthorizationData(response.access_token, response.access_token).then(() => {
                this.AuthService.setTokenHeader();
                this.returnToOriginalState();
            });
        })
        .catch((response) => {});
    }
}

export const login: aboTheme.IComponent = {
    bindings: { returnTo: '<' },
    controller: LoginController,
    template: require('./index.html')
}; 


// WEBPACK FOOTER //
// ./src/app/authorization/login/index.ts